<template>
  <section>
    请看Table页
  </section>
</template>

<script>
export default {}

</script>

<style scoped>

</style>
